import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './filters'
import '@/styles'
import '@/mixins/global'
import IdleVue from 'idle-vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import version from '../version.json'
import VueCookies from 'vue-cookies'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

const eventsHub = new Vue()

const isLocal = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
if (!isLocal) {
  Sentry.init({
    dsn: 'https://9360f24efcb445cfb3a2a14767fd0dfd@sentry.logs.imbellus.com/11',
    integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })],
    release: version.version + '#' + version.revision
  })

  Sentry.setTag('environment', window.location.host)
}

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 14400000 // 4hr
})

Vue.use(VueCookies)
Vue.$cookies.config('1d')

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
